// extracted by mini-css-extract-plugin
export default {"mapHistory":"LocationHistory_mapHistory__P5mFz","popup":"LocationHistory_popup__Hz5Os"};